import { render, staticRenderFns } from "./ProductsView.vue?vue&type=template&id=477de2e3"
import script from "./ProductsView.vue?vue&type=script&lang=js"
export * from "./ProductsView.vue?vue&type=script&lang=js"
import style0 from "./ProductsView.vue?vue&type=style&index=0&id=477de2e3&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3066951572/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('477de2e3')) {
      api.createRecord('477de2e3', component.options)
    } else {
      api.reload('477de2e3', component.options)
    }
    module.hot.accept("./ProductsView.vue?vue&type=template&id=477de2e3", function () {
      api.rerender('477de2e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProductsView.vue"
export default component.exports